import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import AILearningHome from './pages/Home';
import Pricing from './pages/Pricing';
import Library from './pages/Library';
import Login from './pages/Login';
import Register from './pages/Register';
import Unsubscribe from './pages/Unsubscribe';
import ForgotPassword from './pages/ForgotPassword';
import MyAccount from './pages/MyAccount';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import ScrollToTop from './component/ScrollToTop';
import TrailingSlashRedirect from './component/TrailingSlashRedirect';
import Seo from './component/Seo';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute, GuestRoute, SubscriptionRoute, NoSubscriptionOnlyRoute, AdminRoute } from './component/ProtectedRoute';
import Checkout from './pages/Checkout';
import Imprint from './pages/Imprint';
import LiveClasses from './pages/LiveClasses';
import NotFound from './pages/NotFound';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <TrailingSlashRedirect />
        <Seo />
        <Routes>
          <Route path="/" element={<AILearningHome />} />
          {/* Library requires active subscription */}
          <Route path="/library" element={
            <SubscriptionRoute><Library /></SubscriptionRoute>
          } />
          <Route path="/live-classes" element={
            <AdminRoute><LiveClasses /></AdminRoute>
          } />
          <Route path="/pricing" element={<NoSubscriptionOnlyRoute><Pricing /></NoSubscriptionOnlyRoute>} />
          {/* Guest-only routes — redirect to /account if already logged in */}
          <Route path="/login" element={
            <GuestRoute><Login /></GuestRoute>
          } />
          <Route path="/register" element={
            <GuestRoute><Register /></GuestRoute>
          } />
          <Route path="/signup" element={
            <GuestRoute><Register /></GuestRoute>
          } />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/imprint" element={<Imprint />} />
          {/* Account requires login */}
          <Route path="/account" element={
            <ProtectedRoute><MyAccount /></ProtectedRoute>
          } />
          {/* 404 Not Found */}
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
